import { joinPath } from '../../core/utils';
import type { RunPolicyBlockOptions, RunPolicyPaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveRunPolicyPaths(prefix: string, options?: RunPolicyBlockOptions): RunPolicyPaths {
  const segment = options?.fieldSegment ?? 'runStrategy';
  return {
    strategy: joinPath(prefix, segment),
  };
}
